import { cn } from 'domain/core';

export const commonInputClassName = cn('w-auto', 'py-2', 'px-2', 'text-sm');
